if (!customElements.get('pf-sticky-atc')) {
  customElements.define('pf-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-variant-provider') || document;
      this.bindMainButton = this.bindMainButton.bind(this);
      this.evaluate = this.evaluate.bind(this);
      this.mutationObserver = new MutationObserver(this.bindMainButton);
      this.mutationObserver.observe(this.root, { childList: true, subtree: true });
      this.media = window.matchMedia('(max-width: 749px)');
      this.media.addEventListener?.('change', this.evaluate);
      this.bindMainButton();
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.media?.removeEventListener?.('change', this.evaluate);
    }

    bindMainButton() {
      const nextButton = this.root.querySelector('[data-product-meta] [data-to-cart]');
      if (!nextButton || nextButton === this.mainButton) return;
      this.mainButton = nextButton;
      this.intersectionObserver?.disconnect();
      this.intersectionObserver = new IntersectionObserver(this.evaluate, { threshold: 0 });
      this.intersectionObserver.observe(this.mainButton);
      requestAnimationFrame(this.evaluate);
    }

    evaluate() {
      if (!this.mainButton) {
        this.removeAttribute('data-visible');
        return;
      }
      const show = this.media.matches && this.mainButton.getBoundingClientRect().bottom < 0;
      this.toggleAttribute('data-visible', show);
    }
  });
}